// One line for the panel's identity strip when Scout has written a state.
//
// The format is fixed: Scout: state · source. The fit score used to sit between them; it is
// retired from every strategist-facing surface (2 Oct 2026), so a missing source drops out of
// the line rather than leaving an empty slot. Nothing when `scout_state` is unset — absence
// is absence.

import type { BookAccount } from '../api/types';

export function scoutFactLine(row: BookAccount): string | null {
  if (!row.scout_state) return null;

  const parts = [row.scout_state];
  if (row.scout_source) parts.push(row.scout_source);
  return `Scout: ${parts.join(' · ')}`;
}
